import { usePointCloudContext } from 'features/pointClouds'
import React, { FC } from 'react'
import styled from 'styled-components'

import { HudObservationPanel } from './HudObservationPanel'
import { ObservationButton } from './ObservationButton'
import { ObservationEditHudPanel } from './ObservationEditHudPanel'

const ObservationContainer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
`

const ButtonWrapper = styled.div`
  z-index: 10;
  position: relative;
`

interface HudObservationOverlayContainerProps {
  isOpen: boolean
  onToggle: (isOpen: boolean) => void
}

export const HudObservationOverlayContainer: FC<
  HudObservationOverlayContainerProps
> = ({ isOpen, onToggle }) => {
  const { editingObservation } = usePointCloudContext()

  return (
    <ObservationContainer>
      <ButtonWrapper>
        <ObservationButton
          isSelected={isOpen}
          setIsSelected={() => onToggle(!isOpen)}
        />
      </ButtonWrapper>
      <HudObservationPanel isOpen={isOpen} />
      <ObservationEditHudPanel
        isOpen={!!editingObservation}
        observation={editingObservation ?? undefined}
      />
    </ObservationContainer>
  )
}
